import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AddMember = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5001 0C12.7763 0 13.0001 0.223858 13.0001 0.5V3H15.5001C15.7763 3 16.0001 3.22386 16.0001 3.5C16.0001 3.77614 15.7763 4 15.5001 4H13.0001V6.5C13.0001 6.77614 12.7763 7 12.5001 7C12.224 7 12.0001 6.77614 12.0001 6.5V4H9.50012C9.22398 4 9.00012 3.77614 9.00012 3.5C9.00012 3.22386 9.22398 3 9.50012 3H12.0001V0.5C12.0001 0.223858 12.224 0 12.5001 0ZM7.23107 1.54333C7.51345 1.51131 7.75012 1.74056 7.75012 2.02474C7.75012 2.29343 7.53761 2.51205 7.27105 2.54578C4.43964 2.90406 2.25012 5.32133 2.25012 8.25C2.25012 9.85769 2.90992 11.3113 3.97351 12.3547C5.05297 11.5823 6.46975 11.125 8.00012 11.125C9.53049 11.125 10.9473 11.5823 12.0267 12.3547C13.0903 11.3113 13.7501 9.85769 13.7501 8.25C13.7501 7.97185 13.9667 7.73301 14.2449 7.73301H14.2701C14.5299 7.73301 14.7477 7.93326 14.7499 8.19302L14.7501 8.25C14.7501 11.9779 11.728 15 8.00012 15C4.2722 15 1.25012 11.9779 1.25012 8.25C1.25012 4.78212 3.86529 1.92505 7.23107 1.54333ZM11.2184 13.0157C10.3522 12.465 9.2359 12.125 8.00012 12.125C6.76434 12.125 5.64803 12.465 4.78185 13.0157C5.70022 13.6371 6.80779 14 8.00012 14C9.19245 14 10.3 13.6371 11.2184 13.0157ZM9.62512 7.6875C9.62512 8.58496 8.89758 9.3125 8.00012 9.3125C7.10266 9.3125 6.37512 8.58496 6.37512 7.6875C6.37512 6.79004 7.10266 6.0625 8.00012 6.0625C8.89758 6.0625 9.62512 6.79004 9.62512 7.6875ZM10.6251 7.6875C10.6251 9.13725 9.44987 10.3125 8.00012 10.3125C6.55037 10.3125 5.37512 9.13725 5.37512 7.6875C5.37512 6.23775 6.55037 5.0625 8.00012 5.0625C9.44987 5.0625 10.6251 6.23775 10.6251 7.6875Z"
        fill={color}
      />
    </svg>
  )
})

export default AddMember
